import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import { APP_BASENAME } from './config/constants';
import CopyrightPage from './pages/CopyrightPage';
import BooksPage from './pages/BooksPage';
import BookDetailsPage from './pages/BookDetailsPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import AdminDashboard from './pages/admin/AdminDashboard';
import ManageUsers from './pages/admin/ManageUsers';
import AddBook from './pages/admin/AddBook';
import ManageBooks from './pages/admin/ManageBooks';
import ManageCollections from './pages/admin/ManageCollections';
import ReportsPage from './pages/admin/ReportsPage';
import ManageContact from './pages/admin/ManageContact';
import UserProfile from './pages/user/UserProfile';
import FavoritesPage from './pages/user/FavoritesPage';
import RecommendationsPage from './pages/RecommendationsPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import CategoriesPage from './pages/CategoriesPage';
import BlogPage from './pages/BlogPage';
import BlogPost from './components/BlogPost';
import ManageBlog from './pages/admin/ManageBlog';
import HelpPage from './pages/HelpPage';
import TermsPage from './pages/TermsPage';
import FAQPage from './pages/FAQPage';
import PrivacyPage from './pages/PrivacyPage';
import CookiesPage from './pages/CookiesPage';
import ManageLegalPages from './pages/admin/ManageLegalPages';
import ExtendedFeaturesPage from './pages/ExtendedFeaturesPage';

const Router: React.FC = () => {
  return (
    <BrowserRouter basename={APP_BASENAME || undefined}>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/copyright" element={<CopyrightPage />} />
        <Route path="/books" element={<BooksPage />} />
        <Route path="/books/:id" element={<BookDetailsPage />} />
        <Route path="/categories" element={<CategoriesPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/profile" element={<UserProfile />} />
        <Route path="/favorites" element={<FavoritesPage />} />
        <Route path="/recommendations" element={<RecommendationsPage />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/users" element={<ManageUsers />} />
        <Route path="/admin/books/add" element={<AddBook />} />
        <Route path="/admin/books" element={<ManageBooks />} />
        <Route path="/admin/collections" element={<ManageCollections />} />
        <Route path="/admin/contact" element={<ManageContact />} />
        <Route path="/admin/reports" element={<ReportsPage />} />
        <Route path="/admin/legal-pages" element={<ManageLegalPages />} />
        <Route path="/admin/blog" element={<ManageBlog />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/cookies" element={<CookiesPage />} />
        <Route path="/functionalitati-extinse" element={<ExtendedFeaturesPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
